import {
  IProductoImportado,
  IProductoImportadoError,
} from "../pages/importadorProductos/interface/IImportadorProductos";

export const Types = {
  IMPORTADOR_LOADING: "IMPORTADOR_LOADING",
  IMPORTADOR_LOADING_DOWNLOAD: "IMPORTADOR_LOADING_DOWNLOAD",

  DESCARGAR_TEMPLATE_REQUEST: "DESCARGAR_TEMPLATE_REQUEST",
  DESCARGAR_TEMPLATE_SUCCEEDED: "DESCARGAR_TEMPLATE_SUCCEEDED",
  DESCARGAR_TEMPLATE_ERROR: "DESCARGAR_TEMPLATE_ERROR",

  IMPORTAR_PRODUCTOS_REQUEST: "IMPORTAR_PRODUCTOS_REQUEST",
  IMPORTAR_PRODUCTOS_SUCCEEDED: "IMPORTAR_PRODUCTOS_SUCCEEDED",
  IMPORTAR_PRODUCTOS_ERROR: "IMPORTAR_PRODUCTOS_ERROR",

  CONFIRMAR_IMPORTACION_REQUEST: "CONFIRMAR_IMPORTACION_REQUEST",
  CONFIRMAR_IMPORTACION_SUCCEEDED: "CONFIRMAR_IMPORTACION_SUCCEEDED",
  CONFIRMAR_IMPORTACION_ERROR: "CONFIRMAR_IMPORTACION_ERROR",

  LIMPIAR_ESTADO: "LIMPIAR_ESTADO",
};

export const startLoading = () => ({ type: Types.IMPORTADOR_LOADING });
export const startLoadingDownload = () => ({
  type: Types.IMPORTADOR_LOADING_DOWNLOAD,
});

export const descargarTemplate = () => ({
  type: Types.DESCARGAR_TEMPLATE_REQUEST,
});
export const descargarTemplateSuccess = () => ({
  type: Types.DESCARGAR_TEMPLATE_SUCCEEDED,
});
export const descargarTemplateError = (err: any) => ({
  type: Types.DESCARGAR_TEMPLATE_ERROR,
  err,
});

export const importarProductos = (formData: { file: File[] }) => ({
  type: Types.IMPORTAR_PRODUCTOS_REQUEST,
  formData,
});
export const importarProductosSuccess = (
  productosEncontrados: IProductoImportado[],
  productosNoEncontrados: IProductoImportadoError[],
  parentId: string,
) => ({
  type: Types.IMPORTAR_PRODUCTOS_SUCCEEDED,
  productosEncontrados,
  productosNoEncontrados,
  parentId,
});
export const importarProductosError = (err: any) => ({
  type: Types.IMPORTAR_PRODUCTOS_ERROR,
  err,
});

export const confirmarImportacion = (parentId: string) => ({
  type: Types.CONFIRMAR_IMPORTACION_REQUEST,
  parentId,
});
export const confirmarImportacionSuccess = (successMessage: string) => ({
  type: Types.CONFIRMAR_IMPORTACION_SUCCEEDED,
  successMessage,
});
export const confirmarImportacionError = (err: any) => ({
  type: Types.CONFIRMAR_IMPORTACION_ERROR,
  err,
});

export const limpiarEstado = () => ({ type: Types.LIMPIAR_ESTADO });
